import { axios } from '@/libraries/axios'
import { attempt, call, rows } from '@/libraries/api'
import { confirm, success } from '@/libraries/toast'
import type { define as Tenant } from '@/components/tenant/interfaces'
import type { Stored, WriteResult } from '@/types/api'

/* Asks for confirmation, then pushes the tenant's configuration to its agent. */
export function sendConfiguration(_key: string, target: HTMLElement): void {
  confirm('Yes, send configuration!', target, async () => {
    if (await attempt(() => axios.put(`/api/katana/setup/${_key}`))) success()
  })
}

export function list() {
  return rows(() => axios.get<Stored<Tenant>[]>('/api/tenant'))
}

export function get(_key: string) {
  return call(() => axios.get<Stored<Tenant>>(`/api/tenant/${_key}`), null)
}

export function create(body: Partial<Tenant>) {
  return call(() => axios.post<WriteResult>('/api/tenant', body), null)
}

export function update(_key: string, body: Partial<Tenant>) {
  return call(() => axios.patch<WriteResult>(`/api/tenant/${_key}`, body), null)
}

export function remove(_key: string) {
  return attempt(() => axios.delete(`/api/tenant/${_key}`))
}
